class GrapheneHc extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupGraphene()
  }

  setupListeners () {
    super.setupListeners()

    this.handlePagination = this.handlePagination.bind(this)
    this.setCollectionDetails = this.setCollectionDetails.bind(this)

    this.listeners.add(this, 'click', this.handlePagination)
  }

  setupGraphene () {
    const pageType = this.dataset.type

    // eslint-disable-next-line no-undef
    graphenehc.load({
      template: {
        id: pageType,
        target: '[data-graphene-hc-el="product-grid"]',
      },
      include: ['breadcrumb', 'page'],
      page_context: {
        currency_id: window.Shopify.country,
      },
      success: (response) => {
        const responseData = response.templates[pageType]

        if (pageType === 'search') {
          this.handleReplaceContent('search-header')

          const categoriesEl = document.querySelector(
            '[data-graphene-hc-el="empty-categories"]',
          )

          if (categoriesEl) {
            categoriesEl.setAttribute(
              'aria-hidden',
              response.templates[pageType].product_count > 0,
            )
          }
        }

        this.handleReplaceContent('filters-drawer-trigger')
        this.handleReplaceContent('clear-all')
        this.handleReplaceContent('available-toggle')
        this.handleReplaceContent('filters-drawer')

        // Available now
        const availableToggleEl = document.querySelector(
          '[data-graphene-hc-el="available-toggle"]',
        )
        const gridHeaderEl = document.querySelector(
          '[data-graphene-hc-el="grid-header"]',
        )
        gridHeaderEl.classList.toggle(
          'clc-ProductGridHeader-hasAvailable',
          availableToggleEl.innerHTML.trim() !== '',
        )

        // Promotions
        const promoEls = document.querySelectorAll(
          '[data-graphene-hc-el="promo"]',
        )
        promoEls.forEach((promoEl) => {
          const findItemEl = document.querySelector(
            `[data-graphene-hc-el="item"][data-index="${promoEl.dataset.position}"]`,
          )

          if (findItemEl) {
            findItemEl.insertAdjacentHTML('beforebegin', promoEl.innerHTML)
          }
        })

        this.setupColours()
        this.setPriceLabels()
        this.setCollectionDetails(responseData)

        window.BAO.dispatchEvent(window.BAO.EVENTS.WISHLIST.CHECK_WISHLIST)
      },
    })
  }

  handleReplaceContent (elementReference) {
    const mainEl = document.querySelector(
      `[data-graphene-hc-el="${elementReference}"]`,
    )
    const grapehenEl = document.querySelector(
      `[data-graphene-hc-el="graphene-${elementReference}"]`,
    )

    if (!mainEl || !grapehenEl) return

    mainEl.innerHTML = grapehenEl.innerHTML
    grapehenEl.innerHTML = ''
  }

  setPriceLabels () {
    const priceLabelEls = document.querySelectorAll(
      '[data-graphene-hc-el="price-label"]',
    )

    if (!priceLabelEls) return

    priceLabelEls.forEach((priceLabelEl) => {
      priceLabelEl.setAttribute(
        'aria-label',
        `${window.theme.currencySymbol}${priceLabelEl.dataset.labelNumber}`,
      )
    })
  }

  handlePagination (event) {
    const pageType = this.dataset.type

    const paginationTrigger = event.target.closest(
      '[data-graphene-hc-el="pagination"]',
    )

    if (!paginationTrigger) return

    event.preventDefault()

    const paginationDirection = paginationTrigger.dataset.direction
    const pageToLoad =
      paginationDirection === 'next'
        ? this.currentHighestPage + 1
        : this.currentLowestPage - 1

    // eslint-disable-next-line no-undef
    graphenehc.load_page({
      page_number: pageToLoad,
      set_page_url: true,
      success: (response) => {
        const responseData = response.templates[pageType]

        const newPageData = responseData.html
        const currentItemsContainer = document.querySelector(
          '[data-graphene-hc-el="items"]',
        )
        const parsedHTML = new DOMParser().parseFromString(
          newPageData,
          'text/html',
        )

        const newItems = document.createDocumentFragment()
        const newElements = parsedHTML.querySelectorAll(
          '[data-graphene-hc-el="item"]',
        )

        newElements.forEach((el) => newItems.appendChild(el))

        if (paginationDirection === 'next') {
          currentItemsContainer.append(newItems)
        } else {
          currentItemsContainer.prepend(newItems)
        }

        this.setCollectionDetails(responseData)
      },
    })
  }

  setCollectionDetails (responseData) {
    const pageType = this.dataset.type

    this.setAttribute('data-total-pages', responseData.page_count)
    this.setAttribute('data-total-products', responseData.product_count)
    this.setAttribute('data-products-per-page', responseData.page_size)

    const pageDifference = this.currentHighestPage - this.currentLowestPage + 1
    const showingCount =
      pageDifference * this.productsPerPage > this.totalProducts
        ? this.totalProducts
        : pageDifference * this.productsPerPage

    this.els['pagination-showing'].element.textContent = showingCount
    this.els['pagination-total'].element.textContent = this.totalProducts

    this.els['grid-header'].element.setAttribute(
      'aria-hidden',
      responseData.product_count === 0,
    )

    if (pageType === 'category') {
      const canonicalEl = document.querySelector('link[rel="canonical"]')
      const previousEl = document.querySelector('link[rel="prev"]')
      const nextEl = document.querySelector('link[rel="next"]')

      if (canonicalEl) {
        if (responseData.current_page > 1) {
          canonicalEl.href = `${this.dataset.url}?pg=${responseData.current_page}`
        } else {
          canonicalEl.href = `${this.dataset.url}`
        }
      }

      if (nextEl) {
        nextEl.remove()
      }
      if (previousEl) {
        previousEl.remove()
      }

      if (responseData.current_page < responseData.page_count) {
        const newNextEl = document.createElement('link')
        newNextEl.href = `${this.dataset.url}?pg=${responseData.current_page + 1}`
        newNextEl.rel = 'next'

        document.getElementsByTagName('head')[0].appendChild(newNextEl)
      }
      if (responseData.current_page > 1) {
        const newPrevEl = document.createElement('link')
        if (responseData.current_page === 2) {
          newPrevEl.href = `${this.dataset.url}`
        } else {
          newPrevEl.href = `${this.dataset.url}?pg=${responseData.current_page - 1}`
        }
        newPrevEl.rel = 'prev'

        document.getElementsByTagName('head')[0].appendChild(newPrevEl)
      }
    }

    this.els.pagination.elements.forEach((paginationEl) => {
      if (paginationEl.dataset.direction === 'next') {
        paginationEl.setAttribute(
          'aria-hidden',
          this.totalProducts === 0
            ? true
            : this.currentHighestPage === this.totalPages,
        )

        if (pageType === 'category') {
          if (this.currentHighestPage < this.totalPages) {
            paginationEl.href = `${this.dataset.url}?pg=${this.currentHighestPage + 1}`
          } else {
            paginationEl.href = `${this.dataset.url}?pg=${this.currentHighestPage}`
          }
        }
      } else {
        paginationEl.setAttribute(
          'aria-hidden',
          this.totalProducts === 0 ? true : this.currentLowestPage === 1,
        )

        if (pageType === 'category') {
          if (this.currentLowestPage > 2) {
            paginationEl.href = `${this.dataset.url}?pg=${this.currentLowestPage - 1}`
          } else {
            paginationEl.href = `${this.dataset.url}`
          }
        }
      }
    })
  }

  setupColours () {
    const colourEls = document.querySelectorAll(
      '[data-graphene-hc-el="colour"]',
    )

    if (!colourEls) return

    colourEls.forEach((colourEl) => {
      const colourKey = colourEl.dataset.colour

      if (colourKey && Array.isArray(window.theme?.colours)) {
        const matchedColour = window.theme.colours.find(
          (colour) => colour.name === colourKey,
        )

        if (matchedColour) {
          colourEl.style.setProperty('--Swatch_Colour', matchedColour.hex)
          colourEl.style.setProperty('--Swatch_Border', matchedColour.hex)
        }
      }
    })
  }

  get currentLowestPage () {
    const productGridItems = document.querySelectorAll(
      '[data-graphene-hc-el="item"]',
    )

    return productGridItems.length > 0
      ? Number(productGridItems[0].dataset.page) || 1
      : 0
  }

  get currentHighestPage () {
    const productGridItems = document.querySelectorAll(
      '[data-graphene-hc-el="item"]',
    )

    return productGridItems.length > 0
      ? Number(productGridItems[productGridItems.length - 1].dataset.page) || 1
      : 0
  }

  get totalPages () {
    return parseInt(this.dataset.totalPages)
  }

  get totalProducts () {
    return parseInt(this.dataset.totalProducts)
  }

  get productsPerPage () {
    return parseInt(this.dataset.productsPerPage)
  }
}

if (!customElements.get('graphene-hc')) {
  customElements.define('graphene-hc', GrapheneHc)
}
